import script from "./RalColorSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./RalColorSelect.vue?vue&type=script&setup=true&lang=js"

import "./RalColorSelect.vue?vue&type=style&index=0&id=6ac5413a&scoped=true&lang=css"

import exportComponent from "/var/www/html/projects/rde/resources/vueapps/quotation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac5413a"]])

export default __exports__